import styled from "styled-components";
import {
  StyledBaseSection,
  StyledBaseSectionInner,
} from "../../styled/BaseSection.styled";
import { device } from "../../../style/util/media-query";
import { Paragraph } from "../../general/Paragraph/Paragraph";
import Divider from "../../general/Divider/Divider";
import { alignCenter } from "../../../style/util/align-center";
import { size } from "../../../style/util/size";
import { pulse2 } from "../../../style/util/animation";

export const StyledSection = styled(StyledBaseSection)`
  overflow: hidden;
`;

export const StyledSectionInner = styled(StyledBaseSectionInner)`
  @media ${device.desktop} {
    padding: 6rem 0 2rem;
  }
`;

export const StyledHeadingWrapper = styled.div`
  text-align: center;

  @media ${device.desktop} {
    display: none;
  }
`;

export const StyledList = styled.ul`
  margin: 4.3rem 0;

  @media ${device.tablet} {
    margin: 6rem 0;
  }

  @media ${device.desktop} {
    display: flex;
    justify-content: space-between;
  }
`;

export const StyledItem = styled.li`
  text-align: center;

  @media ${device.desktop} {
    width: 32.3%;

    h3 {
      width: calc(100% + 1em);
    }

    &:first-of-type {
      text-align: right;
      margin-bottom: 0;

      h3 {
        margin-left: -0.8em;
      }
    }

    &:last-of-type {
      text-align: left;
    }
  }
`;

export const StyledSubtitle = styled(Paragraph)`
  font-style: italic;
`;

export const StyledDescription = styled(Paragraph)`
  margin: 2rem 0;
  width: 100%;

  @media ${device.desktop} {
    margin: 2.2rem 0 0;
  }
`;

export const StyledItemFigure = styled.li`
  position: relative;
  width: 100%;
  padding: 5% 16.5%;
  margin-bottom: 19vw;

  @media ${device.tablet} {
    width: 30rem;
    padding: 6rem 0;
    margin: 0 auto 4rem;
  }

  @media ${device.desktop} {
    width: 35.4%;
    padding: 0;
    margin-bottom: 0;
  }
`;

export const StyledFigure = styled.figure`
  position: relative;
  width: 100%;

  @media ${device.desktop} {
    ${alignCenter()};
    width: 58%;
  }
`;

export const StyledBottle = styled.img`
  ${size("100%", "auto")};
  position: relative;

  @media ${device.desktop} {
    margin-bottom: 28%;
  }
`;

export const StyledBottleBlur = styled(StyledBottle)`
  filter: blur(1.5rem) brightness(1.5);
  mix-blend-mode: hard-light;
  animation: ${pulse2} 3s infinite;
  position: absolute;
  top: 0;
`;

export const StyledBottleReflection = styled.img`
  ${size("100%", "auto")};
  position: absolute;
  left: 0;
  top: 85%;

  @media ${device.desktop} {
    top: 75%;
  }
`;

export const StyledSmoke = styled.img`
  position: absolute;
  width: 216%;
  top: 50%;
  left: 50%;
  transform: translateX(-43%) translateY(-63%);
`;

export const StyledDivider = styled(Divider)`
  width: 94%;
  margin: 0;

  @media ${device.desktop} {
    width: 82%;
    margin: 1.3rem 0 1.5rem;
  }
`;
